module.exports = __webpack_public_path__ + "static/WorcationBaseimg-0be3bbae785f8f812fded0fe87a59cf6.svg";